// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { MarketplaceHealthPost } from '../../../../types/server/modules/marketplaceHealth/post';

export type * from '../../../../types/server/modules/marketplaceHealth/post';

export const createPost = ( requests: Requests ): MarketplaceHealthPost => ({
  marketplace_health_force_sync: Object.assign(( params, body,headers ) => {
      return requests.post( `/marketplace-health/:connectorId/force-sync`, { ...params, body }, headers );
    }, { operation: 'marketplace-health:marketplace-health-force-sync', route: 'POST /marketplace-health/:connectorId/force-sync', subdomain: 'marketplace-health', visibility: 'private' } as const )
});
